import { Dispatch } from 'react';
import { getTwilioAccessToken } from 'services/chatService';
import {
  GET_TWILIO_ACCESS_TOKEN_REQUEST,
  GET_TWILIO_ACCESS_TOKEN_SUCCESS,
  GET_TWILIO_ACCESS_TOKEN_FAILURE,
} from 'state/actionTypes/twilioActionTypes';
import { TwilioAction } from 'state/contexts/TwilioContext/TwilioContext.types';

type GetTwilioAccessTokenAction = (dispatch: Dispatch<TwilioAction>) => Promise<void>;
export const getTwilioAccessTokenAction: GetTwilioAccessTokenAction = async (
  dispatch,
) => {
  dispatch({ type: GET_TWILIO_ACCESS_TOKEN_REQUEST });
  try {
    const { twilioAccessToken } = await getTwilioAccessToken();
    dispatch({
      type: GET_TWILIO_ACCESS_TOKEN_SUCCESS,
      payload: twilioAccessToken,
    });
  } catch (err) {
    dispatch({
      type: GET_TWILIO_ACCESS_TOKEN_FAILURE,
      payload: (err as Error).message,
    });
  }
};
